import { MessageSquare } from 'lucide-react'
import type { PortalPjFeedback } from '@/services/portalPjFeedbackService'

type Props = {
  items: PortalPjFeedback[]
  loading: boolean
  error: string | null
}

function formatDate(iso: string) {
  return new Date(iso).toLocaleString('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  })
}

export function PortalPjFeedbackSection({ items, loading, error }: Props) {
  if (loading) {
    return (
      <div className='flex justify-center py-12'>
        <div className='h-8 w-8 animate-spin rounded-full border-2 border-[#e91e63] border-t-transparent' />
      </div>
    )
  }

  if (error) {
    return <p className='text-sm text-red-300'>{error}</p>
  }

  if (items.length === 0) {
    return (
      <div className='rounded-lg border border-dashed border-white/15 bg-white/[0.03] px-4 py-10 text-center'>
        <MessageSquare className='mx-auto mb-3 text-white/45' size={28} />
        <p className='text-sm font-medium text-white'>
          Nenhum feedback disponível ainda
        </p>
        <p className='mt-1 text-xs text-white/55'>
          Quando sua liderança liberar um feedback, ele aparecerá aqui.
        </p>
      </div>
    )
  }

  return (
    <ul className='space-y-4'>
      {items.map((item) => (
        <li
          key={item.id}
          className='rounded-xl border border-[#e91e63]/25 bg-white/[0.05] p-4 shadow-sm'
        >
          <p className='whitespace-pre-wrap text-sm leading-relaxed text-white'>
            {item.conteudo}
          </p>
          <p className='mt-3 text-xs text-white/55'>
            {item.authorName} · {formatDate(item.liberadoEm)}
          </p>
        </li>
      ))}
    </ul>
  )
}
